import React from 'react';
import { Link } from 'react-router-dom';

const Unauthorized = () => {
  return (
    <div className="container text-center" style={{ marginTop: '100px' }}>
      <h2>Unauthorized Access</h2>
      <p>You don't have permission to access this page.</p>
      <Link to="/dashboard">Return to Dashboard</Link>
    </div>
  );
};

export default Unauthorized;